exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sermon-player[data-v-ef5183a6] {\n  background-color: #c8c8c8;\n}\nimg[data-v-ef5183a6] {\n  display: block;\n  margin: 0 auto;\n  width: 100%;\n}", ""]);

// exports
